<div class="modal-header" appCustomAutofocus>
        <h3 class="modal-title" *ngIf="Languages['Confirm Cash-Out Request'] == null">Confirm Cash-Out Request</h3>
        <h3 class="modal-title" *ngIf="Languages['Confirm Cash-Out Request'] != null">{{Languages["Confirm Cash-Out Request"]["TranslateLabel"]}}</h3>
    </div>
    <div class="modal-body">
        You are requesting to cash out {{cashHours}} hours for the pay period ending on {{payPeriod}}.
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="submitClicked()" *ngIf="Languages['Submit'] == null">
            Submit
        </button>
        <button type="button" class="btn btn-success" (click)="submitClicked()" *ngIf="Languages['Submit'] != null">
            {{Languages["Submit"]["TranslateLabel"]}}
        </button>
        <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()" *ngIf="Languages['Cancel'] == null">
            Cancel
        </button>
        <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()" *ngIf="Languages['Cancel'] != null">
            {{Languages["Cancel"]["TranslateLabel"]}}
        </button>
    </div>